class Auth {
  constructor() {
    this.user_token = JSON.parse(localStorage.getItem("auth")) || {};
  }
  getToken() {
    return this.user_token.token;
  }
  getUserId() {
    return JSON.parse(localStorage.getItem("auth"));
  }
  setUserToken(new_token) {
    this.user_token = new_token;
    localStorage.setItem("auth", JSON.stringify(new_token));
  }
  logout() {
    localStorage.removeItem("access_token");
    localStorage.removeItem("auth");
    localStorage.removeItem("customerData");
    localStorage.removeItem("workData");
    localStorage.removeItem("techData");
    localStorage.removeItem("jobCountData");
    localStorage.removeItem("siteID");
    localStorage.removeItem("splashShowed");
    localStorage.removeItem("unsyu");
    localStorage.removeItem("profiledata");
    localStorage.removeItem("permissions");
    localStorage.removeItem("selected_tenant");
    localStorage.removeItem("user_tenant");
    localStorage.removeItem("notiCountData");
    localStorage.removeItem("notificationData");
    sessionStorage.removeItem("siteID");
    window.location.href = "/";
  }
}
export default new Auth();
